<template>
  <div class="main-content container-fluid fixed">
    <div class="purchase-product row">
      <div class="col-1"></div>
      <main class="col-8">
        <div class="inside-info">
          <div class="row">
            <div class="col">
              <MemberInfoBar />
            </div>
          </div>

          <div class="row purchase-list">
            <div class="col-12">
              <div class="purchase-list__title">
                購買商品
              </div>

              <div class="filter-area">
                <div class="one-filter sort-filter">
                  <div class="one-filter__title">
                    分類
                  </div>
                  <b-form-select
                    v-model="parentId"
                    class="d-xl-none w-50 m-auto"
                    :options="parentCategorySelectorOptions"
                  ></b-form-select>

                  <ul class="one-filter__items d-none d-xl-flex">
                    <template
                      v-for="(parentCategory, index) in parentCategories"
                    >
                      <li
                        class="filter-radio col-2"
                        :key="index"
                        v-if="showAllSortFilter ? index >= 0 : index < 6"
                      >
                        <input
                          type="radio"
                          v-model="parentId"
                          :value="parentCategory.parent_id"
                          :id="'parent_' + index"
                          @click="cancelParentRadio(parentCategory.parent_id)"
                        />
                        <label :for="'parent_' + index">
                          {{ parentCategory.name }}
                        </label>
                      </li>
                    </template>
                  </ul>

                  <div
                    class="icon-arrow_d d-none d-xl-block"
                    :class="{ active: showAllSortFilter }"
                    @click="handleShowAllSort"
                  ></div>
                </div>

                <div class="one-filter product-filter">
                  <div class="one-filter__title">
                    商品
                  </div>

                  <b-form-select
                    v-model="childId"
                    class="d-xl-none w-50 m-auto"
                    :options="childCategorySelectorOptions"
                  ></b-form-select>

                  <ul class="one-filter__items d-none d-xl-flex">
                    <template v-for="(childCategory, index) in childCategories">
                      <li
                        class="filter-radio col-2"
                        v-if="showAllProductFilter ? index >= 0 : index < 6"
                        :key="index"
                      >
                        <input
                          type="radio"
                          v-model="childId"
                          :value="childCategory.child_id"
                          :id="'child_' + index"
                          @click="cancelChildRadio(childCategory.child_id)"
                        />
                        <label :for="'child_' + index">
                          {{ childCategory.name }}
                        </label>
                      </li>
                    </template>
                  </ul>
                  <div
                    class="icon-arrow_d d-none d-xl-block"
                    :class="{ active: showAllProductFilter }"
                    @click="handleShowAllProduct"
                  ></div>
                </div>

                <div class="one-filter size-filter">
                  <div class="one-filter__title">
                    規格
                  </div>

                  <b-form-select
                    v-model="specId"
                    class="d-xl-none w-50 m-auto"
                    :options="specSelectorOptions"
                  ></b-form-select>

                  <ul class="one-filter__items d-none d-xl-flex">
                    <template v-for="(spec, index) in specs">
                      <li
                        class="filter-radio col-2"
                        v-if="showAllSize ? index >= 0 : index < 6"
                        :key="index"
                      >
                        <input
                          type="radio"
                          v-model="specId"
                          :value="spec.spec_id"
                          :id="'spec_' + index"
                          @click="cancelSpecRadio(spec.spec_id)"
                        />
                        <label :for="'spec_' + index">{{ spec.name }}</label>
                      </li>
                    </template>
                  </ul>

                  <div
                    class="icon-arrow_d d-none d-xl-block"
                    :class="{ active: showAllSize }"
                    @click="handleShowAllSize"
                  ></div>
                </div>
              </div>
            </div>

            <OneProduct
              v-for="(product, index) in productList"
              :key="index"
              :id="index"
              :product="product"
              @chooseProduct="chooseProduct"
            />
          </div>
          <infinite-loading @infinite="infiniteHandler" ref="loadingComponent">
            <template v-slot:no-results>
              <p>已無更多資訊</p>
            </template>
            <template v-slot:no-more>
              <p>已無更多資訊</p>
            </template>
          </infinite-loading>
        </div>
      </main>
      <SidebarMenu :memberId="memberId" />
      <ProductModal :product="choseProduct" :push="true" />
    </div>
  </div>
</template>

<script>
import SidebarMenu from '@/components/Layouts/SidebarMenu';
import OneProduct from '@/components/PurchaseProduct/OneProduct';
import ProductModal from '@/components/Modal/ProductModal';
import {
  fetchParentCategories,
  fetchChildCategories,
  fetchSpecs,
  fetchProducts,
  fetchProduct
} from '@/api/product';
import { mapGetters } from 'vuex';
import cloneDeepWith from 'lodash/cloneDeepWith';
import MemberInfoBar from '@/components/MemberInfoBar';

export default {
  components: {
    SidebarMenu,
    OneProduct,
    ProductModal,
    MemberInfoBar
  },
  computed: {
    ...mapGetters('order', ['products']),
    ...mapGetters('member', ['memberId', 'branchId']),
    productFilters() {
      return {
        page: this.page,
        member_id: this.memberId,
        parent_category_id: this.parentId,
        child_category_id: this.childId,
        spec_id: this.specId
      };
    },
    parentCategorySelectorOptions() {
      if (!this.parentCategories.length) {
        return [];
      }

      return this.parentCategories.map(item => ({
        text: item.name,
        value: item.parent_id
      }));
    },
    childCategorySelectorOptions() {
      if (!this.childCategories.length) {
        return [];
      }

      return this.childCategories.map(item => ({
        text: item.name,
        value: item.child_id
      }));
    },
    specSelectorOptions() {
      if (!this.specs.length) {
        return [];
      }

      return this.specs.map(item => ({
        text: item.name,
        value: item.spec_id
      }));
    }
  },
  watch: {
    parentId() {
      // 重新選擇主分類時清空已選的次分類跟規格

      // 若是選擇次分類而變更主分類 則次分類不清空
      if (this.isChooseByChild === false) {
        this.childId = '';
      }

      this.specId = '';

      this.resetFetchProducts();

      this.fetchChildCategories();

      this.fetchSpecs();

      this.isChooseByChild = false;
    },
    childId() {
      // 重新選擇次分類時清空已選的規格
      this.specId = '';

      if (this.parentId == '') {
        this.isChooseByChild = true;

        this.setParentId();
      }

      this.resetFetchProducts();

      this.fetchSpecs();
    },
    specId() {
      this.resetFetchProducts();
    }
  },
  data() {
    return {
      mobile: '',
      uniformNum: '',
      phone: '',
      parentId: '',
      childId: '',
      specId: '',
      parentCategories: [],
      childCategories: [],
      specs: [],
      showAllSortFilter: false,
      showAllProductFilter: false,
      showAllSize: false,
      productList: [],
      fetchedProducts: [],
      choseProduct: {},
      isChooseByChild: false,
      page: 0,
      total: 0
    };
  },
  created() {
    this.fetchParentCategories();

    this.fetchChildCategories();

    this.fetchSpecs();
  },
  methods: {
    async infiniteHandler($state) {
      this.page += 1;

      fetchProducts(this.productFilters, productList => {
        if (productList.data.length) {
          this.productList.push(...productList.data);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    handleShowAllSort() {
      this.showAllSortFilter = !this.showAllSortFilter;
    },
    handleShowAllProduct() {
      this.showAllProductFilter = !this.showAllProductFilter;
    },
    handleShowAllSize() {
      this.showAllSize = !this.showAllSize;
    },
    fetchParentCategories() {
      fetchParentCategories(parentCategories => {
        this.parentCategories = parentCategories;
      });
    },
    fetchChildCategories() {
      let params = {
        parent_id: this.parentId
      };

      fetchChildCategories(params, childCategories => {
        this.childCategories = childCategories;
      });
    },
    fetchSpecs() {
      let params = {
        parent_id: this.parentId,
        product_category_id: this.childId
      };

      fetchSpecs(params, specs => {
        this.specs = specs;
      });
    },
    fetchProducts() {
      fetchProducts(this.productFilters, productList => {
        this.productList = productList.data;
        this.total = productList.total;
      });
    },
    fetchProduct(member_id, id, branch_id, cb) {
      fetchProduct({ member_id, id, branch_id }, product => {
        this.fetchedProducts.push(product);

        if (cb) {
          cb(product);
        }
      });
    },
    chooseProduct(choseProductId) {
      let fetchedProduct = this.fetchedProducts.find(
        product => product.product_id == choseProductId
      );

      if (fetchedProduct == null) {
        this.fetchProduct(
          this.memberId,
          choseProductId,
          this.branchId,
          product => {
            this.openModal(product);
          }
        );
      } else {
        this.openModal(fetchedProduct);
      }
    },
    openModal(fetchedProduct) {
      this.choseProduct = cloneDeepWith(fetchedProduct);

      this.$bvModal.show(`product-modal-purchase-product`);
    },
    setParentId() {
      let category = this.childCategories.find(
        child => child.child_id == this.childId
      );

      if (category) {
        this.parentId = category.parent_id;
      }
    },
    cancelParentRadio(newParentId) {
      if (newParentId == this.parentId) {
        this.parentId = '';
      }
    },
    cancelChildRadio(newChildId) {
      if (newChildId == this.childId) {
        this.childId = '';
      }
    },
    cancelSpecRadio(newSpecId) {
      if (newSpecId == this.specId) {
        this.specId = '';
      }
    },
    resetFetchProducts() {
      this.page = 0;
      this.productList = [];
      this.$refs.loadingComponent.stateChanger.reset();
    }
  }
};
</script>
